{
  "common_action_cancel": "Отменить",
  "common_action_submit": "Сохранить",
  "common_action_upload": "Загрузить",
  "common_tab_attach": "Загрузить с устройства",
  "common_tab_link": "Добавить по ссылке",
  "common_link": "Ссылка",
  "common_sizes": "Размер в пикселях",
  "iframe_link_help": "Ссылка на ресурс, который будет отображаться в фрейме.",
  "iframe_sizes_help": "Ширина и высота фрейма в пикселях.",
  "image_name": "Подпись к рисунку",
  "image_link_href": "Ссылка картинки",
  "image_link_href_help": "Адрес, на который ведет картинка.",
  "image_alt": "Альтернативный текст",
  "image_alt_help": "Текст будет отображаться, если не удастся загрузить изображение.",
  "image_upload_help": "Изображение в формате JPEG, GIF и PNG размером не более 1 МБ.",
  "image_upload_failed": "Не удалось загрузить изображение",
  "image_size_width": "Ширина",
  "image_size_height": "Высота",
  "link_url_help": "Адрес, на который ведет ссылка.",
  "link_text": "Текст",
  "link_text_help": "Текст, который отображается как ссылка.",
  "link_open_help": "Открыть ссылку в новой вкладке",
  "file_link_help": "Ссылка для загрузки файла",
  "file_name": "Название файла",
  "file_upload_help": "Загружайте сразу несколько файлов с устройства.",
  "file_upload_failed": "Не удалось загрузить файлы",
  "anchor_href": "Идентификатор якоря",
  "anchor_href_help": "Cостоит из цифр, символов и латинских букв. Якоря используются для навигации по странице.",
  "anchor_title": "Подсказка",
  "anchor_title_help": "Текст всплывающей подсказки при наведении на элемент якоря",
  "form_id": "Ссылка или ID формы"
}
